import { Chip } from '@mui/material';
import DynamicIcon, { IconName } from '@shared/components/Icon';

export function pretty(s?: string) {
  return (s || '').replace(/_/g, ' ').replace(/\b\w/g, m => m.toUpperCase());
}

export function getStatusMeta(status?: string): {
  label: string;
  chipClass: string;
  icon: React.ReactElement | undefined;
} {
  const s = (status || '').toLowerCase();
  switch (s) {
    case 'active':
      return {
        label: 'Active',
        chipClass: 'intelligence-request-card__chip--active',
        icon: <DynamicIcon iconName={IconName.TaskAlt} />,
      };
    case 'cancelled':
      return {
        label: 'Cancelled',
        chipClass: 'intelligence-request-card__chip--grey',
        icon: <DynamicIcon iconName={IconName.CancelOutlined} />,
      };
    case 'expired':
      return {
        label: 'Expired',
        chipClass: 'intelligence-request-card__chip--grey',
        icon: <DynamicIcon iconName={IconName.HourglassEmptyOutlined} />,
      };
    case 'fulfilled':
      return {
        label: 'Fulfilled',
        chipClass: 'intelligence-request-card__chip--engagement',
        icon: <DynamicIcon iconName={IconName.DoneAllOutlined} />,
      };
    case 'accepted_by_review_author':
      return {
        label: 'Accepted by Author',
        chipClass: 'intelligence-request-card__chip--bounty',
        icon: <DynamicIcon iconName={IconName.HandshakeOutlined} />,
      };
    case 'paused':
      return {
        label: 'Paused',
        chipClass: 'intelligence-request-card__chip--engagement',
        icon: <DynamicIcon iconName={IconName.PauseCircleOutlined} />,
      };
    case 'pending':
      return {
        label: 'Pending',
        chipClass: 'intelligence-request-card__chip--status',
        icon: <DynamicIcon iconName={IconName.HourglassTopOutlined} />,
      };
    case 'rejected':
      return {
        label: 'Rejected',
        chipClass: 'intelligence-request-card__chip--error',
        icon: <DynamicIcon iconName={IconName.BlockOutlined} />,
      };
    default:
      return {
        label: pretty(status) || 'Unknown',
        chipClass: 'intelligence-request-card__chip--grey',
        icon: undefined,
      };
  }
}

export function renderStatusChip(status?: string) {
  const { label, chipClass, icon } = getStatusMeta(status);
  return (
    <Chip
      className={`intelligence-request-card__chip ${chipClass}`}
      icon={icon}
      label={label}
      size="small"
    />
  );
}
